import { render, staticRenderFns } from "./UnBlockInboundCall.vue?vue&type=template&id=499aaa98&scoped=true&"
import script from "./UnBlockInboundCall.vue?vue&type=script&lang=js&"
export * from "./UnBlockInboundCall.vue?vue&type=script&lang=js&"
import style0 from "./UnBlockInboundCall.vue?vue&type=style&index=0&id=499aaa98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499aaa98",
  null
  
)

export default component.exports